module.exports = __webpack_public_path__ + "static/media/screenshot-discord.334abf08.jpg";